import styled from 'styled-components'
import query from 'mediaQueries'

import { ReactNode } from 'react'

export const TopHeaderBar = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid ${({ theme }): string => theme.header.border};
  background-color: ${({ theme }): string => theme.header.background};
  max-height: 64px;
  @media ${query.greaterThanMedium} {
    padding: 16px 32px;
    max-height: 80px;
  }
`

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  height: 72px;
`

const Logo = styled.img`
  height: 45px;
  margin-left: 32px;

  @media ${query.lessThanMedium} {
    margin-left: 1rem;
  }
`

interface BaseHeaderProps {
  logo: ReactNode
  children?: ReactNode
}

const BaseHeader = ({ logo, children }: BaseHeaderProps) => {
  return (
    <TopHeaderBar>
      <LogoContainer>{logo}</LogoContainer>
      {children}
    </TopHeaderBar>
  )
}

interface HeaderWithLogoProps {
  logoSrc: string
  logoAlt: string
}

const HeaderWithLogo = ({ logoSrc, logoAlt }: HeaderWithLogoProps) => {
  return (
    <TopHeaderBar>
      <LogoContainer>
        <Logo src={logoSrc} alt={logoAlt} />
      </LogoContainer>
    </TopHeaderBar>
  )
}

export default BaseHeader

export { Logo, HeaderWithLogo }
